
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./ScrollEvents": function() {
return Promise.all([__webpack_require__.e("777"), __webpack_require__.e("90"), __webpack_require__.e("707"), __webpack_require__.e("658"), __webpack_require__.e("55")]).then(function() { return function() { return __webpack_require__(2209); }; });
},
"./LeaderBoard": function() {
return Promise.all([__webpack_require__.e("777"), __webpack_require__.e("90"), __webpack_require__.e("942"), __webpack_require__.e("707"), __webpack_require__.e("622"), __webpack_require__.e("153"), __webpack_require__.e("778")]).then(function() { return function() { return __webpack_require__(9689); }; });
},
"./useFetchLeaderboardSheet": function() {
return Promise.all([__webpack_require__.e("777"), __webpack_require__.e("90"), __webpack_require__.e("707"), __webpack_require__.e("658"), __webpack_require__.e("237")]).then(function() { return function() { return __webpack_require__(2106); }; });
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };